import { sh as reactsh } from '@ews/react-translations';

const sh = {
...reactsh
}
export default sh
